module.exports = __webpack_public_path__ + "img/bg-clothes2.6715c150.png";